import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.css'
})
export class BannerComponent {
  @Input() adminUserInfo: { userName: string | null, email: string | null, tenantId: string | null } = { userName: null, email: null, tenantId: null };
  @Input() isAdminLoggedIn: boolean = false;
  @Input() tenantName: string | null = null;

}
